import {
    getSubscriptions,
    checkPromocode,
    createPayment,
    cancelPayment,
    getMyPromocode,
    updateMyPromocode,
    getMyReferrals,
    getCustomPlanSettings,
} from './agent';

import { readReferrals } from './referrals';

import type { AxiosError } from 'axios';
import type { PromoCodeUpdate } from 'src/types/Subscription';

class SubscriptionsService {
    queryKey = 'subscriptions';

    getSubscriptionsList = async () => {
        try {
            const { data } = await getSubscriptions();
            const normalized = Array.isArray(data)
                ? data.map((p: any) => {
                      const isAdmin = Boolean(p?.is_admin_custom);
                      const fixed = Number(p?.fixed_price ?? NaN);
                      const priceNum = Number(p?.price ?? 0) || 0;
                      const effectivePrice = isAdmin && Number.isFinite(fixed) && fixed > 0 ? fixed : priceNum;
                      return {
                          ...p,
                          price: effectivePrice,
                          is_admin_custom: isAdmin,
                      };
                  })
                : data;
            return Promise.resolve(normalized);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getCustomPlanSettings = async () => {
        try {
            const { data } = await getCustomPlanSettings();

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    checkPromocode = async (code: string) => {
        try {
            const { data } = await checkPromocode(code);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject((error as AxiosError).response?.data);
        }
    };

    getMyPromocode = async () => {
        try {
            const { data } = await getMyPromocode();

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    updateMyPromocode = async (data: PromoCodeUpdate) => {
        try {
            const { data: responseData } = await updateMyPromocode(data);

            return Promise.resolve(responseData);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getMyReferrals = async () => {
        try {
            const { data } = await getMyReferrals();

            return Promise.resolve(readReferrals(data));
        } catch (error) {
            return Promise.reject(error);
        }
    };

    createPayment = async (body) => {
        try {
            const { data } = await createPayment(body);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    cancelSubscription = async () => {
        try {
            await cancelPayment();

            return Promise.resolve({});
        } catch (error) {
            return Promise.reject(error);
        }
    };
}

export default new SubscriptionsService();
